import { render, staticRenderFns } from "./KonvaDeleteElement.vue?vue&type=template&id=491685df&scoped=true"
import script from "./KonvaDeleteElement.vue?vue&type=script&lang=js"
export * from "./KonvaDeleteElement.vue?vue&type=script&lang=js"
import style0 from "./KonvaDeleteElement.vue?vue&type=style&index=0&id=491685df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491685df",
  null
  
)

export default component.exports